import { message, Upload } from 'antd';

export const allowedImageMimeTypes = ['image/jpeg', 'image/png', 'image/webp'];
export const allowedAnimationMimeTypes = ['video/mp4', 'video/quicktime', 'video/webm'];
export const maxImageUploadBytes = 5 * 1024 * 1024;
export const maxAnimationUploadBytes = 25 * 1024 * 1024;

export const validateImageFile = (file: File | Blob & { type?: string; size?: number; name?: string }) => {
  const type = file.type || '';
  const size = file.size || 0;

  if (!allowedImageMimeTypes.includes(type)) {
    return 'Images must be JPEG, PNG, or WebP.';
  }

  if (size > maxImageUploadBytes) {
    return 'Images must be 5MB or smaller.';
  }

  return '';
};

export const rejectInvalidImageUpload = (file: File) => {
  const error = validateImageFile(file);

  if (error) {
    message.error(error);
    return Upload.LIST_IGNORE;
  }

  return false;
};

export const filterValidImageFiles = <T extends Blob & { type?: string; size?: number }>(files: T[]) =>
  files.filter((file) => !validateImageFile(file));

export const validateAnimationFile = (file: File | Blob & { type?: string; size?: number; name?: string }) => {
  const type = file.type || '';
  const size = file.size || 0;

  if (!allowedAnimationMimeTypes.includes(type)) {
    return 'Animation must be MOV, MP4, or WebM.';
  }

  if (size > maxAnimationUploadBytes) {
    return 'Animation must be 25MB or smaller.';
  }

  return '';
};

export const rejectInvalidAnimationUpload = (file: File) => {
  const error = validateAnimationFile(file);

  if (error) {
    message.error(error);
    return Upload.LIST_IGNORE;
  }

  return false;
};
